import React, { Component } from 'react';
import { connect } from 'react-redux';

import { addError } from 'actions';
import { getNotifications } from 'actions/notifications';
import { setPageTitle, setPageActions } from 'actions/header';

import FromNow from 'components/Presentation/Date/FromNow';
import Alert from 'components/Presentation/Notifications/Alert';

import getEnvironment from 'lib/env';

import { getActiveLanguage, translate, Skeleton } from '@haldor/ui';

class Notifications extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			optionsModalVisible: false
		};
	}

	componentDidMount = async () => {
		this.props.setPageTitle(this.props.translate('notifications'));

		if (this.props.lcid != null) {
			await this.getNotifications(this.props.lcid);
		}
		else {
			await this.getNotifications('en-US')
		}
	}

	getNotifications = async (lcid) => {
		this.setState({ loading: true });

		if (lcid.toLowerCase() == 'sv-se') {
			await this.props.getNotifications(lcid);
		} else if (lcid.toLowerCase() == 'da-dk') {
			await this.props.getNotifications(lcid);
		} else if (lcid.toLowerCase() == 'nb-no') {
			await this.props.getNotifications(lcid);
		} else if (lcid.toLowerCase() == 'uk') {
			await this.props.getNotifications(lcid);
		} else {
			await this.props.getNotifications("en-US");
		}

		this.setState({ loading: false });
	}

	onOptionsSubmit = (values) => new Promise((resolve) => {
		resolve(1);
	});

	toggleOptionModal = () => {
		this.setState({ optionsModalVisible: !this.state.optionsModalVisible });
	}

	closeOptionsModal = () => {
		this.setState({ optionsModalVisible: false });
	}

	render() {
		const { notifications } = this.props;
		const { domains } = getEnvironment();

		return (
			<div className="section latest" style={{ margin: 0, padding: 0, border: 0 }}>
				{this.state.loading ?
					<div>
						<Alert type="news">
							<Skeleton />
						</Alert>
					</div>
					: notifications != null && notifications.length == 0 ?
						<div className="color--meta text--center weight--bold">
							{this.props.translate('no-new-notifications')}
						</div>
						: null}

				{notifications != null && notifications.length > 0 ?
					<div>
						{notifications.map((notification, i) => {
							if (notification.referenceUrl !== null) {
								var url = new URL(notification.referenceUrl);

								if (domains.length > 0 && !domains.some((domain) => { return domain === url.hostname })) {
									var correctHost = domains[0];
									url.host = correctHost;
								}

								return (
									<a href={url.href} key={i}>
										<Alert id={i} type="news" key={i}>
											<div className="subtitle">
												<FromNow utc>{notification.created}</FromNow>
											</div>

											{notification.notificationText}
										</Alert>
									</a>
								);
							}

							return (
								<Alert id={i} type="news" key={i}>
									<div className="subtitle">
										<FromNow utc>{notification.created}</FromNow>
									</div>

									{notification.notificationText}
								</Alert>
							);
						})}
					</div>
					: null}
			</div>
		);
	}
}

function mapStateToProps(state) {
	var notifications = [];

	if (state.Notifications != null) {
		if (state.Notifications.notifications != null) {
			state.Notifications.notifications.forEach((notCol) => {
				notifications = notifications.concat(notCol.notifications);
			});

			notifications = notifications.sort((a, b) => { return b.id - a.id });
		}
	}

	return {
		notifications: notifications,
		translate: translate(state.Languages.translations),
		languages: state.Languages.languages,
		currentUser: state.user.currentUser,
		lcid: getActiveLanguage(),
	};
}

export default connect(mapStateToProps, {
	addError,
	getNotifications,
	setPageTitle,
	setPageActions,
})(Notifications);
